<section class="bg-(--bg-color) relative flex flex-col min-h-screen transition-all duration-300 ">
  <div class="grid grid-cols-12 grow relative z-2">

    <!-- Sidebar (hidden on mobile) -->
    <aside class="hidden lg:flex col-span-12 lg:col-span-2 bg-(--bg-color) pt-6 pb-10 flex-col border-r border-[#DAE1E4]/50 rtl:border-l 
      rtl:border-r-0 transition-all duration-300">
      <app-sidebar></app-sidebar>
    </aside>

    <!-- Main Content -->
    <main class="col-span-12 lg:col-span-10 flex flex-col">
      <!-- Header -->
      <app-header (toggleSidebar)="toggleSidebar()"></app-header>

      <!-- Main Dynamic Content -->
       <div style="height:calc(100% - 91px)">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>

  <!-- Blur Glow -->
  <div class="fixed right-[-250px]
         bottom-[-150px] lg:bottom-[-100px]
         w-[900px] h-[400px] rounded-[50%]
         bg-[#1654F4]/30 blur-[220px]
         z-3 pointer-events-none select-none
         transition-all duration-300
         rtl:left-[-250px] rtl:right-auto">
  </div>

  <!-- Mobile Sidebar Overlay -->
  <div class="fixed inset-0 bg-black/40 z-50 lg:hidden transition-opacity duration-300" *ngIf="isSidebarOpen"
    (click)="toggleSidebar()">
  </div>

  <!-- Mobile Drawer Sidebar -->
<aside
  class="fixed top-0 h-full w-72 bg-(--bg-color) shadow-lg z-60 transform transition-transform duration-300 lg:hidden"
  [ngClass]="{
    'left-0 -translate-x-full': direction === 'ltr' && !isSidebarOpen,
    'left-0 translate-x-0': direction === 'ltr' && isSidebarOpen,
    'right-0 translate-x-full': direction === 'rtl' && !isSidebarOpen,
    'right-0 translate-x-0': direction === 'rtl' && isSidebarOpen
  }"
>
  <div class="flex items-center justify-between p-4 border-b border-[#DAE1E4]/50 rtl:flex-row-reverse">
    <a routerLink="/">
      <img src="assets/images/Alawneh-Logo-side.png" [alt]="'LOGIN.LOGO_ALT' | translate" />
    </a>

    <button
      (click)="toggleSidebar()"
      class="text-(--brand-primary) text-xl transition-all duration-200 cursor-pointer"
    >
      ✕
    </button>
  </div>

  <app-sidebar></app-sidebar>
</aside>

</section>